module.exports = __webpack_public_path__ + "img/mockup.d1dc8c80.png";